import t, { Children as n } from "react";
import { cls as c } from "../../../../../../../../helpers/cls.js";
const _ = e => e === "single",
  a = _ref => {
    let {
      children: e,
      isLarge: l
    } = _ref;
    return t.createElement("div", {
      className: c("olx-header__tiles-grid__tile", {
        "olx-header__tiles-grid__tile--large": l
      })
    }, e);
  },
  m = _ref2 => {
    let {
      rowLayouts: e,
      children: l
    } = _ref2;
    let r = 0,
      i = 0;
    return t.createElement("div", {
      className: "olx-header__tiles-grid"
    }, n.map(l, s => {
      const o = e[r] === "pair" ? 2 : 1;
      i >= o && (r++, i = 0);
      const d = _(e[r]);
      return i++, t.createElement(a, {
        key: "tile-".concat(r, "-").concat(i),
        isLarge: d
      }, s);
    }));
  };
export { a as TileDiv, m as TilesGrid };